import { LinkOutlined } from '@ant-design/icons';
import React from 'react';

export default [
{
    path: '/iframe/:code',
    component: './Frame',
    icon: <LinkOutlined />,
  },
{
    path: '/in-site-message/inbox',
    name: '我的站内信',
    hideInMenu: true,
    component: './InSiteMessage/Inbox',
  },
{
    path: '/external/:code',
    hideInMenu: true,
    component: './ExternalRedirect',
  },
{
    path: '/404',
    hideInMenu: true,
    component: './404',
  },
{
    path: '*',
    redirect: '/404',
  }
];
